import React from 'react';
import Card from '../card/Card';
import './App.scss';


function App() {
  return (
    <div className="App">
      <Card />
    </div>
  );
}

export default App;
